<template>
  <v-dialog v-model="dialog" max-width="900" transition="dialog-bottom-transition" scrollable>
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar flat dark color="secondary">
          <v-toolbar-title>Panduan Penilaian {{ title }}</v-toolbar-title>
          <v-spacer />
          <v-btn right icon dark @click="onClose">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pb-0 black--text">
        <template v-if="kategori === 'guru'">
          <v-row class="pa-0">
            <v-col cols="12">
              <div class="blue--text body-1"> <strong>SKALA PENILAIAN</strong> </div>
              <v-divider />
            </v-col>
            <v-col cols="12">
              <template v-for="item in skala">
                <v-row :key="item.skor" no-gutters dense class="my-n1">
                  <v-col cols="12" md="4" sm="12">
                    <v-responsive
                      :class="
                        `text-center white--text ${item.color} rounded-circle d-inline-flex align-center justify-center`
                      "
                      height="25"
                      width="25"
                    >
                      {{ item.skor === 'NA' ? item.skor : Number(item.skor) + min }}
                    </v-responsive>
                    <strong class="mx-2">{{ item.title }}</strong>
                  </v-col>
                  <v-col cols="12" md="8" sm="12">
                    <p class="ml-n10">{{ item.desc }}</p>
                  </v-col>
                </v-row>
              </template>
            </v-col>
            <v-col cols="12">
              <b
                >Catatan: Tidak semua perilaku di BARS akan relevan untuk semua individu. Perilaku ini adalah contoh
                kinerja yang membentuk setiap tingkat efektivitas.
              </b>
            </v-col>
            <v-col cols="12">
              <div class="blue--text body-1"> <strong>ADAPUN PENILAIAN TERLAMPIR</strong> </div>
              <v-divider />
            </v-col>
            <v-col cols="12">
              <ul>
                <li> Jika tidak ditemukan bukti perilaku dari kandidat <b>maka pilih NA</b>. </li>
                <li>
                  Jika bukti perilaku individu sebagian besar cocok dengan pernyataan kurang memenuhi persyaratan,
                  <b>maka beri nilai 1</b>
                </li>
                <li>
                  Jika bukti perilaku individu sebagian cocok dengan pernyataan kurang memenuhi persyaratan dan sebagian
                  cocok dengan pernyataan memenuhi persyaratan, <b>maka beri nilai 2</b>
                </li>
                <li>
                  Jika bukti perilaku individu sebagian besar cocok dengan pernyataan memenuhi persyaratan,
                  <b>maka beri nilai 3</b>
                </li>
                <li>
                  Jika bukti perilaku individu sebagian cocok dengan pernyataan memenuhi persyaratan dan sebagian cocok
                  dengan pernyataan melebihi persyaratan, <b>maka beri nilai 4</b>
                </li>
                <li>
                  Jika bukti perilaku individu sebagian besar cocok dengan pernyataan melebihi persyaratan,
                  <b>maka beri nilai 5</b>
                </li>
              </ul>
            </v-col>
          </v-row>
        </template>
        <template v-else>
          <v-row class="pa-0 pt-5">
            <v-col cols="12">
              <div class="blue--text body-1">
                <strong>{{ $getDeepObj(items, 'label') || '' }}</strong>
              </div>
              <v-divider />
              <span class="subtitle-1 font-weight-bold">Definisi</span>
              <div>{{ $getDeepObj(items, 'desc') || '' }}</div>
            </v-col>
            <v-col cols="12">
              <div class="blue--text body-1">
                <strong>PANDUAN PENILAIAN</strong>
              </div>
              <v-divider />
              <template v-for="item in skala">
                <v-row :key="item.skor" no-gutters dense class="my-5">
                  <v-col cols="12" md="1" sm="12">
                    <v-responsive
                      :class="`text-center white--text ${item.color} d-inline-flex align-center justify-center`"
                      height="45"
                      width="45"
                      style="font-size: 15pt; border-radius: 3px"
                    >
                      {{ item.skor === 'NA' ? item.skor : Number(item.skor) + min }}
                    </v-responsive>
                  </v-col>
                  <v-col cols="12" md="11" sm="11">
                    <div class="font-weight-bold">{{
                      labels.length ? (item.skor !== 'NA' ? labels[item.skor] || '' : item.title) : item.title
                    }}</div>
                    <p class="grey--text">{{ item.desc }}</p>
                    <div style="line-height: 24px">
                      <template v-if="($getDeepObj(items, `esais.${item.skor}`) || []).length > 1">
                        <ul>
                          <li v-for="list in $getDeepObj(items, `esais.${item.skor}`) || []" :key="list">
                            {{ list }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        <span>{{ $getDeepObj(items, `esais.${item.skor}`)[0] || '' }}</span>
                      </template>
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <div class="text-right">
          <v-btn class="mr-2" color="blue" right dark @click="onClose"> OK </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'PopupPanduanEsai',
  props: {
    title: {
      type: String,
      default: 'Esai',
    },
    min: {
      type: Number,
      default: 0,
    },
    labels: {
      type: Array,
      default: () => [],
    },
    useNa: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dialog: false,
      isChecked: false,
      kategori: '',
      items: {},
    };
  },
  computed: {
    skala() {
      let temp = [
        {
          skor: '4',
          title: 'Luar Biasa ( Exeptional )',
          desc: 'Hampir selalu menunjukkan perilaku yang sangat efektif',
          color: 'success',
        },
        {
          skor: '3',
          title: 'Kuat ( Strong )',
          desc: 'Sering menunjukkan perilaku yang sangat efektif',
          color: 'blue',
        },
        {
          skor: '2',
          title: 'Sedang ( Moderate )',
          desc: 'Biasanya menunjukkan perilaku yang efektif',
          color: 'yellow darken-3',
        },
        {
          skor: '1',
          title: 'Terbatas ( Limited )',
          desc: 'Menunjukkan beberapa perilaku efektif tetapi dengan kualitas atau konsistensi terbatas',
          color: 'orange darken-3',
        },
        {
          skor: '0',
          title: 'Lemah ( Weak )',
          desc: 'Menunjukkan perilaku yang tidak efektif dan melewatkan peluang untuk perilaku yang efektif',
          color: 'red',
        },
      ];

      if (this.useNa) {
        temp.push({
          skor: 'NA',
          title: 'Tidak Tersedia',
          desc: 'Tidak ada perilaku yang dapat diamati (jawaban esai kosong)',
          color: 'grey',
        });
      }
      return temp;
    },
  },
  methods: {
    open(kategori, items) {
      this.kategori = kategori || 'guru';
      this.items = items;
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    onClose() {
      this.dialog = false;
    },
  },
};
</script>
